import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import "../styles/Item.css";
import "../styles/ItemDetails.css";
import { styled, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import locales from "../../../_constants/locales";
import Item from "../containers/Item";
import Dialog from "@material-ui/core/Dialog";
import StyledButtonCancel from "../../../components/StyledButtonCancel.jsx";

class ItemDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.item) {
            return null;
        }

        return (
            <Dialog open={this.props.open} className="item-details-dialog" onClose={this.props.handleClose.bind(this)}>
                <div className="item-details-window section">
                    <div className="header">
                        <h2 className="title">
                            {locales[this.props.language.code].ITEM_DETAILS.TYPE[this.props.type.toUpperCase()]}{" "}
                            {locales[this.props.language.code].ITEM_DETAILS.TITLE}
                        </h2>
                    </div>
                    <div>
                        <Item item={this.props.item} type={this.props.type} disabled={true} showDetails={true} />
                    </div>
                    <div className="footer layout horizontal end-justified">
                        <StyledButtonCancel onClick={this.props.handleClose.bind(this)} variant="contained">
                            {locales[this.props.language.code].BUTTON.CLOSE.LABEL}
                        </StyledButtonCancel>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default ItemDetails;
